import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {SelectItem} from 'primeng/api';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-multiselect',
    template: `
        <p-listbox [class.ng-dirty]="showError"
                   [options]="to.options"
                   [multiple]="true"
                   [checkbox]="true"
                   [metaKeySelection]="true"
                   [filter]="true"
                   [formControl]="formControl"
                   [formlyAttributes]="field"
        >
        </p-listbox>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldListBox extends FieldType {
}
